import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabaseClient';

export default function SignUp() {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [role, setRole] = useState('student');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [alternatePhoneNumber, setAlternatePhoneNumber] = useState('');
  const [grade, setGrade] = useState('');
  const navigate = useNavigate();

  const handleSignUp = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          data: {
            full_name: fullName,
            role: role,
          }
        }
      });

      if (error) throw error;

      if (role === 'teacher') {
        await supabase
          .from('teachers')
          .update({ phone_number: phoneNumber })
          .eq('id', data.user.id);
      } else {
        await supabase
          .from('students')
          .update({
            phone_number: phoneNumber,
            alternate_phone_number: alternatePhoneNumber,
            grade: grade,
          })
          .eq('id', data.user.id);
      }

      alert('Signed up successfully! Please check your email for verification.');
      
      // After successful sign-up, navigate to a new page for student-teacher assignment
      if (role === 'student') {
        navigate('/assign-teacher', { state: { userId: data.user.id } });
      } else {
        navigate('/dashboard');
      }
    } catch (error) {
      console.error('Error during sign up:', error.message);
      alert(`Error during sign up: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSignUp} className="space-y-4">
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
        className="w-full px-3 py-2 border rounded"
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        className="w-full px-3 py-2 border rounded"
      />
      <input
        type="text"
        placeholder="Full Name"
        value={fullName}
        onChange={(e) => setFullName(e.target.value)}
        required
        className="w-full px-3 py-2 border rounded"
      />
      <select
        value={role}
        onChange={(e) => setRole(e.target.value)}
        className="w-full px-3 py-2 border rounded"
      >
        <option value="student">Student</option>
        <option value="teacher">Teacher</option>
      </select>
      <input
        type="tel"
        placeholder="Phone Number"
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        required
        className="w-full px-3 py-2 border rounded"
      />
      {role === 'student' && (
        <>
          <input
            type="tel"
            placeholder="Alternate Phone Number"
            value={alternatePhoneNumber}
            onChange={(e) => setAlternatePhoneNumber(e.target.value)}
            className="w-full px-3 py-2 border rounded"
          />
          <input
            type="text"
            placeholder="Grade"
            value={grade}
            onChange={(e) => setGrade(e.target.value)}
            required
            className="w-full px-3 py-2 border rounded"
          />
        </>
      )}
      <button
        type="submit"
        disabled={loading}
        className="w-full px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-blue-300"
      >
        {loading ? 'Signing up...' : 'Sign Up'}
      </button>
    </form>
  );
}